import { ServiceTypeSelectorOption } from "../../types/order";

/**
 * The customer-facing name of a use case.
 *
 * `service` on an order is the INTERNAL identifier — "venue", "p2p",
 * "moreToCome" — and rendering it raw is how the acceptance screen came to say
 * "Leistung: venue" (#2352). One map, so the label a screen shows is the label
 * of the Buchungen tab the same booking lands on; it was inline in
 * `ServiceTypeSelector`, which is now a caller rather than the owner.
 *
 * An unmapped value falls back to the existing "unknown service" wording — a
 * use case we have no name for is stated as such, never as its identifier.
 */
const SERVICE_LABEL_KEYS: Partial<Record<ServiceTypeSelectorOption, string>> = {
  [ServiceTypeSelectorOption.ALL]: "all",
  [ServiceTypeSelectorOption.RENTAL]: "equipment_rental",
  [ServiceTypeSelectorOption.STORAGE]: "temporary_storage",
  [ServiceTypeSelectorOption.P2P]: "private_handover",
  [ServiceTypeSelectorOption.PARCEL]: "parcel_delivery",
  [ServiceTypeSelectorOption.APARTMENT]: "apartment_rental",
  [ServiceTypeSelectorOption.VENUE]: "venue_reservation",
  [ServiceTypeSelectorOption.HALL]: "hall_reservation",
  [ServiceTypeSelectorOption.SUP]: "sup",
  [ServiceTypeSelectorOption.VOUCHER]: "voucher",
  [ServiceTypeSelectorOption.KEYS]: "keys",
};

/** i18n key (under `service_type_selector`) for one use case identifier. */
export const serviceLabelKey = (service: string | undefined | null): string =>
  SERVICE_LABEL_KEYS[service as ServiceTypeSelectorOption] ?? "unknown_service";

/** Full i18n path, for callers that hold a `t` from any namespace root. */
export const serviceLabelPath = (service: string | undefined | null): string =>
  `service_type_selector.${serviceLabelKey(service)}`;
